







import {Vue, Component, Prop} from 'vue-property-decorator';
@Component
export default class AttachmentRowMobile extends Vue{
@Prop() file?: File;
@Prop() index?: number;
remove(){
    this.$emit("removed",this.index);
}
}
